import React from 'react';
import PageInstructions from '../../../shared/components/PageInstructions';
import { PAGE_MODE } from '../../constants/pageModeTypes';

/**
 * @typedef {object} PageHeaderProps
 * @property {number} [pageMode]
 * @property {boolean} [isAppraiserLicense]
 * @property {boolean} [hasAccessToAscDomain]
 */

/**
 * @param {PageHeaderProps} props
 */
const PageHeader = props => {
  const { pageMode, isAppraiserLicense = false, hasAccessToAscDomain = false } = props;

  const description = isAppraiserLicense
    ? getAppraiserDescription(hasAccessToAscDomain)
    : tierDescriptions.get(pageMode);

  return <PageInstructions title='Assign License' description={description} />;
};

const tierDescriptions = new Map([
  [
    PAGE_MODE.ISACAVipOrg,
    'To assign a license to a user, search for that user by entering their full email address. ' +
      'If the user exists, their name will populate, if the user does not exist, add them to the ' +
      'system by entering their first and last name.  Once all the required information is entered, ' +
      'click the "Assign" button to complete the license assignment to the user.'
  ],
  [
    PAGE_MODE.FDAVipOrg,
    'To assign a license to a user, first search for a user by entering their full email address. ' +
      'If the user exists, their name will populate, if the user does not exist, ' +
      'add them to the system by entering their first and last name. ' +
      'Second, assign the license by choosing the appropriate role from the dropdown. ' +
      'Third, to allow the user access to all data, leave the permission section blank. ' +
      "Selecting one or more organizations in the first list will limit the user's " +
      'access to only those organizations. ' +
      "The user's access may be further limited to specific units within those organizations in the second list. " +
      'Selecting one or more OHTs from the third list will also limit access beyond any previous selections. ' +
      'Once all the required information is entered, ' +
      'click the "Assign" button to complete the license assignment to the user.'
  ],
  [
    PAGE_MODE.MDICVipOrg,
    'To assign a license to a user, first search for a user by entering their full email ' +
      'address. If the user exists, their name will populate, if the user does not exist, add ' +
      'them to the system by entering their first and last name. Second, assign the license by ' +
      'choosing the appropriate role from the dropdown. Once all the required information is ' +
      'entered, click the "Assign" button to complete the license assignment to the ' +
      'user.'
  ],
  [
    PAGE_MODE.MddapOrg,
    'To assign a license to a user, first search for a user by entering their full email ' +
      'address. If the user exists, their name will populate, if the user does not exist, add ' +
      'them to the system by entering their first and last name. Second, assign the license by ' +
      'choosing the appropriate role from the dropdown. Third, to allow the user access to all data, ' +
      "leave the permission section blank. Selecting one or more units in the list will limit the user's " +
      'access to only those units. Once all the required information is ' +
      'entered, click the "Assign" button to complete the license assignment to the ' +
      'user.'
  ],
  [
    PAGE_MODE.OrgUnit,
    'To assign a license to a user, first search for a user by entering their full email ' +
      'address. If the user exists, their name will populate, if the user does not exist, add ' +
      'them to the system by entering their first and last name. Second, assign the license by ' +
      'choosing the appropriate role from the dropdown. Once all the required information is ' +
      'entered, click the "Assign" button to complete the license assignment to the ' +
      'user.'
  ]
]);

const getAppraiserDescription = hasAccessToAscDomain => {
  return (
    'To assign a license to a user, first search for a user by entering their full email address. ' +
    'If the user exists, their name will populate, if the user does not exist, add them to the ' +
    'system by entering their first and last name. Second, choose the appropriate desired and ' +
    'current MDDAP roles from each respective dropdown. If applicable, select the affiliated date ' +
    "from the calendar. Third, enter the user's location by typing their city and state or province " +
    "and selecting the continents for which they're willing to travel (including virtual). " +
    'Finally enter the years of experience for each applicable domain' +
    (hasAccessToAscDomain ? ' and the number of ASC appraisals completed if applicable. ' : '. ') +
    'Once all the required information is entered, ' +
    'click the "Assign" button to complete the license assignment to the user.'
  );
};

export default PageHeader;
